import '../styles/footer.css';
import seal from '../images/tea-seal.png';

const Footer = () => {
  return (
    <footer className="tea-footer">
      <div className="tea-footer__top">

        {/* Logo and address */}
        <div className="tea-footer__column">
          <img alt="Texas Education Agency Seal" className="tea-footer__seal" src={seal} />
        </div>
        <div className="tea-footer__column tea-footer__address">
          <p><strong>Texas Education Agency</strong></p>
          <p>1701 N. Congress Avenue<br />Austin, Texas, 78701</p>
          <p>(512) 463-9734</p>
          <p>
            <a href="https://tea.texas.gov/interiorpage.aspx?id=25769818374">Site Policies</a> | <a href="https://tea.texas.gov/sitemap">Sitemap</a>
          </p>
        </div>

        {/* Multi-column links */}
        <div className="tea-footer__column">
          <a href="https://tea.texas.gov/about-tea/welcome-and-overview/calendars/compact-with-texans">Compact with Texans</a>
          <a href="https://tea.texas.gov/about-tea/contact-us/general-education-complaints">Complaints</a>
          <a href="https://tea.texas.gov/about-tea/other-services/education-service-centers">ESCs</a>
          <a href="https://tea.texas.gov/about-tea/contact-us/general-inquiry/equal-educational-opportunity">Equal Education Opportunity</a>
        </div>
        <div className="tea-footer__column">
          <a href="https://tea.texas.gov/about-tea/contact-us/reporting-fraud-waste-or-abuse-in-texas">Fraud Hotline</a>
          <a href="https://tea.texas.gov/about-tea/contact-us/general-inquiry/general-frequently-asked-questions">FAQ</a>
          <a href="https://gov.texas.gov/organization/disabilities">Governors Committee on People with Disabilities</a>
          <a href="https://gov.texas.gov/organization/hsgd">Homeland Security</a>
          <a href="https://tea.texas.gov/about-tea/other-services/military-family-resources">Military Families</a>
        </div>
        <div className="tea-footer__column">
          <a href="https://tea.texas.gov/about-tea/contact-us/public-information-requests">Public Info Requests</a>
          <a href="https://www.texas.gov/">State of Texas</a>
          <a href="https://capitol.texas.gov/">Texas Legislature</a>
          <a href="https://veterans.portal.texas.gov/">Texas Veterans Portal</a>
          <a href="https://www.tsl.texas.gov/trail/index.html">Trail</a>
          <a href="https://comptroller.texas.gov/transparency/">Where Our Money Goes</a>
        </div>
      </div>

      <div className="tea-footer__bottom">
        © Copyright 2007-2025 Texas Education Agency (TEA). All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
